import { all, takeEvery, select, put } from 'redux-saga/effects';

import { ImageLibraryActions } from '@nextiva/engagement-ui';

import { clearBodyBackgroundImage } from 'styling/actions';
import applyBatchActions from 'utils/applyBatchActions';
import stylingSelectors from 'styling/selectors';

const { getStylingBodyBackgroundImageId } = stylingSelectors;

function* handleRemoveLibraryImage({ payload: removeImageId }) {
  const backgroundImageId = yield select(getStylingBodyBackgroundImageId);
  if (backgroundImageId === removeImageId) {
    yield put(clearBodyBackgroundImage());
  }
}

function* handleBatch(action) {
  yield applyBatchActions(action, {
    [ImageLibraryActions.REMOVE_IMAGE_FROM_IMAGE_UPLOADER_LIBRARY]: handleRemoveLibraryImage,
  });
}

export default function*() {
  yield all([takeEvery(({ meta: { batch } = {} }) => batch, handleBatch)]);
}
